import { useSignalR } from './helpers/useSignalR';

export default function SignalRProvider({ children }) {
  useSignalR();

  return children;
}